var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6034 9.8329L9.35739 8.7849C9.16139 8.6939 9.00039 8.7959 9.00039 9.0129V10.9869C9.00039 11.2039 9.16139 11.3059 9.35739 11.2149L11.6024 10.1669C11.7994 10.0749 11.7994 9.9249 11.6034 9.8329ZM10.0004 0.399902C4.69839 0.399902 0.400391 4.6979 0.400391 9.9999C0.400391 15.3019 4.69839 19.5999 10.0004 19.5999C15.3024 19.5999 19.6004 15.3019 19.6004 9.9999C19.6004 4.6979 15.3024 0.399902 10.0004 0.399902ZM10.0004 13.8999C5.08639 13.8999 5.00039 13.4569 5.00039 9.9999C5.00039 6.5429 5.08639 6.0999 10.0004 6.0999C14.9144 6.0999 15.0004 6.5429 15.0004 9.9999C15.0004 13.4569 14.9144 13.8999 10.0004 13.8999Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.3f299926.svg";
export { ForwardRef as ReactComponent };